import { z } from 'zod';
/**
 * Forma de toda respuesta de la API.
 * Convenciones de Enteratek, seccion 4: respuestas envueltas en { datos, meta }.
 * Seccion 5: errores en { error: { codigo, mensaje, detalles, traza_id } }.
 */
export const esquemaMeta = z
    .object({
    total: z.number().int().nonnegative().optional(),
    cursor: z.string().optional(),
    traza_id: z.string(),
})
    .passthrough();
export const esquemaError = z.object({
    error: z.object({
        /* Dos o tres letras de dominio: HS (hoja de servicio) se nombra con dos,
           igual que el prefijo de su folio. */
        codigo: z.string().regex(/^ETK-[A-Z]{2,3}-\d{3}$/),
        mensaje: z.string(),
        detalles: z.record(z.unknown()).optional(),
        traza_id: z.string(),
    }),
});
//# sourceMappingURL=envoltura.js.map